import React from 'react';
import DealsDetailPage from '../components/DealsDetailPage';

const DealsDetailApp = (props) => (
  <DealsDetailPage {...props} />
);

export default DealsDetailApp;
